import logo from './tilt.gif';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code><b>ScoopSync</b></code>
        </p>
        <a
          className="App-link"
          href="https://twitter.com/lapazena28"
          target="_blank"
          rel="noopener noreferrer"
        >
          @lapazena28
        </a>
      </header>
    </div>
  );
}

export default App;
